<template>
    <div class="hisClient">
        <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="已绑定" name="IsBinding">
                <IsBinding :innerid="innerid"></IsBinding>
            </el-tab-pane>
            <el-tab-pane label="已解绑" name="IsUnbinding">
                <IsUnbinding :innerid="innerid"></IsUnbinding>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import IsBinding from './hisClient/isBinding'
import IsUnbinding from './hisClient/isUnbinding'
export default {
    name: 'hisClient',
    props: ['innerid'],
    data() {
        return {
            activeName: 'IsBinding'
        }
    },
    components: {
        IsBinding, IsUnbinding
    }
}
</script>
<style lang="scss">
    .hisClient{
        .el-tabs__header{
            margin-bottom: 30px !important;
        }
    }
</style>